import { twMerge } from "tailwind-merge";

interface ToggleArrowProps {
  open: boolean;
  onClick: () => void;
}

export const ToggleArrow = ({ open, onClick }: ToggleArrowProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <div
      className={twMerge(
        "flex items-center justify-center cursor-pointer w-6 min-w-6 h-6 min-h-6 border border-purple-600 rounded-md",
        open && "bg-purple-600 shadow-md"
      )}
      onClick={handleClick}
    >
      <i
        className={twMerge(
          "pi pi-chevron-right text-purple-600 text-[10px] font-extrabold",
          open && "text-white pi pi-chevron-down"
        )}
      />
    </div>
  );
};
